import React, { useState, useImperativeHandle, forwardRef } from 'react';

import { string, bool, func } from 'prop-types';

import { useDebounce } from 'Utils';

function SearchInput(
  { value, disabled, placeholder, onChange = () => {} },
  ref
) {
  const [displayValue, setDisplayValue] = useState(value);
  const debouncedChange = useDebounce(onChange, 500);

  const handleChange = (e) => {
    setDisplayValue(e.target.value);
    debouncedChange(e.target.value);
  };

  useImperativeHandle(
    ref,
    () => ({
      setDisplayValue
    }),
    [setDisplayValue]
  );

  return (
    <div
      className="sdp-fieldset sdp-input-search"
      data-testid="searchInput-component"
    >
      <input
        id="search-input"
        type="text"
        placeholder={placeholder}
        className="sdp-form-input"
        value={displayValue}
        onChange={handleChange}
        disabled={disabled}
        data-testid="searchInput-component_input"
      />
    </div>
  );
}

export default forwardRef(SearchInput);

SearchInput.propTypes = {
  value: string,
  disabled: bool,
  placeholder: string,
  onChange: func
};

SearchInput.defaultProps = {
  value: '',
  disabled: false,
  placeholder: '',
  onChange: () => {}
};
